let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("99PJi")).then(() => parcelRequire('1hFWg'));